export const TabHeaders = [
  {
    label: 'Patient Chart',
    width: '90.4px',
  },
];
